import React from "react";
import { connect } from "react-redux";
import * as actions from "../../../../modules/booking/actions";
import { bindActionCreators } from "redux";
import DetailDialog from "../../../booking/dialog/detail";
import moment from "moment";
import { cloneDeep } from "lodash";

const BookingDetail = (props) => {
  const { bookingId, isShow, onClose } = props;
  const [bookingData, setBookingData] = React.useState({});
  const [blockTimes, setBlockTimes] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const currentDay = moment().toDate();
  const WORKING_HOURS = props.auth.user.workingHoursOfWeek;
  const bookingTimeBlock = props.auth.user.booking_time_block

  React.useEffect(() => {
    handleGetBookingDetail();
    handleSetBlockTime();
  }, []);

  const handleGetBookingDetail = React.useCallback(() => {
    window
      .axios({
        url: `/booking/${bookingId}/`,
        method: "get",
      })
      .then((result) => {
        setBookingData(formatDetailBookingData(result.data));
        setIsLoading(false);
      });
  }, [bookingId]);

  const formatDetailBookingData = (data) => {
    const bookingDetail = cloneDeep(data);
    bookingDetail.table = data?.table?.id;
    bookingDetail.shop = data?.shop?.id;
    return bookingDetail;
  };

  const handleSetBlockTime = () => {
    const currDayWorkingHours = getCurrentDayWorkingHour();
    const blockTime = calculateTimeBlocks(currDayWorkingHours);
    setBlockTimes(blockTime);
  };

  const calculateTimeBlocks = (workingHour) => {
    const blocks = [];
    workingHour.forEach((item) => {
      blocks.push(...getBlockTimes(item.start, item.end));
    });

    return blocks;
  };

  const getBlockTimes = (start, end) => {
    const block = [];
    let startTime = start;
    while (moment(startTime).isBefore(moment(end))) {
      block.push(moment(startTime).format("HH:mm"));
      startTime = moment(startTime).add(bookingTimeBlock, "minutes");
    }
    return block;
  };

  const getCurrentWeekOfDay = () => {
    return moment(currentDay).locale("en").format("ddd").toUpperCase();
  };

  const getPreviousDay = () => {
    return moment(currentDay)
      .add(-1, "day")
      .locale("en")
      .format("ddd")
      .toUpperCase();
  };

  const getCurrentDayWorkingHours = () => {
    const currentWeekOfDay = getCurrentWeekOfDay();
    let currDayWorkingHours = WORKING_HOURS.filter(
      (item) => item.dayOfWeek === currentWeekOfDay
    ).map((item) => item.workingHours);

    if (currDayWorkingHours.length) {
      currDayWorkingHours = currDayWorkingHours.reduce((acc, curr) => {
        acc.push(...curr);
        return acc;
      }, []);

      currDayWorkingHours = currDayWorkingHours.filter(
        (item) => item.start < "2400"
      );

      currDayWorkingHours = currDayWorkingHours.map((item) => {
        const hour = cloneDeep(item);

        if (hour.end >= "2400") {
          hour.end = "2359";
        }

        return hour;
      });
    }

    return currDayWorkingHours;
  };

  const getPrevDayWorkingHours = () => {
    const previousDay = getPreviousDay();
    let prevDayWorkingHours = WORKING_HOURS.filter(
      (item) => item.dayOfWeek === previousDay
    ).map((item) => item.workingHours);

    if (prevDayWorkingHours.length) {
      prevDayWorkingHours = prevDayWorkingHours.reduce((acc, curr) => {
        acc.push(...curr);
        return acc;
      }, []);

      prevDayWorkingHours = prevDayWorkingHours
        .filter((item) => item.end > "2400")
        .map((item) => {
          const hour = cloneDeep(item);
          if (hour.start <= "2400") {
            hour.start = "0000";
          } else {
            const startHour = (+hour.start.substr(0, 2) - 24).toString();
            hour.start =
              startHour.length === 1
                ? `0${startHour}${hour.start.substr(2)}`
                : `${startHour}${hour.start.substr(2)}`;
          }

          const endHour = (+hour.end.substr(0, 2) - 24).toString();
          hour.end =
            endHour.length === 1
              ? `0${endHour}${hour.end.substr(2)}`
              : `${endHour}${hour.end.substr(2)}`;

          return hour;
        });
    }
    return prevDayWorkingHours;
  };

  const sortCurrentDayWorkingHour = (currentDay, previousDay) => {
    return [...currentDay, ...previousDay].sort((a, b) => {
      if (a.start > b.start) {
        return 1;
      } else {
        return -1;
      }
    });
  };

  const formatTimeForCurrentDay = (currDayWorkingHours) => {
    return currDayWorkingHours.map((item) => {
      const time = cloneDeep(item);

      time.start = getTimeStart(time);
      time.end = getTimeEnd(time);

      return time;
    });
  };

  const getTimeStart = (time) => {
    return moment(currentDay)
      .set({
        hours: time.start.substr(0, 2),
        minutes: time.start.substr(2),
      })
      .format("YYYY-MM-DDTHH:mmZ");
  };

  const getTimeEnd = (time) => {
    return moment(currentDay)
      .set({
        hours: time.end.substr(0, 2),
        minutes: time.end.substr(2),
      })
      .format("YYYY-MM-DDTHH:mmZ");
  };

  const getCurrentDayWorkingHour = () => {
    let currDayWorkingHours = getCurrentDayWorkingHours();
    let prevDayWorkingHours = getPrevDayWorkingHours();
    const currDayWorkingHoursFormatted = sortCurrentDayWorkingHour(
      currDayWorkingHours,
      prevDayWorkingHours
    );
    return formatTimeForCurrentDay(currDayWorkingHoursFormatted);
  };

  if (!isShow) return null;

  if (isLoading)
    return (
      <div className="loader-wrapper">
        <div className="loader">Loading...</div>
      </div>
    );
  return (
    <DetailDialog
      onClose={onClose}
      data={bookingData}
      blockTimes={blockTimes}
      {...props}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    booking: state.booking,
    auth: state.auth,
    setting: state.setting,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchActions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookingDetail);
